import React, { useState } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Loader from '../../../Components/Utility/Loader/Loader';

function AddToLibrary({ onOpen, Toggle, showLoader, codeName, submitCode, isChecked, handleCheckboxChange, isShow }) {
  const { t } = useTranslation('common');

  const [code, setCode] = useState(codeName);
  const handleChange = (e) => {
    setCode(e.target.value);
  };

  return (
    <Modal show={onOpen} className="common-custom-modal modal-small-2x color-way-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{t('DEVLOPMENT_ORDER.TESTING.ADD_TO_LIBRARY.ADD_UPDATE_TESTING_LIBRARY')}</Modal.Title>
        <span onClick={Toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {showLoader ? (
          <Loader />
        ) : (
          <FormGroup>
            <div className="modal-inner-data">
              <input name="code" className="form-control custom-control-bordered" value={code} type="text" onChange={(e) => handleChange(e)} />
              {isShow && (
                <div className="inputWithMargin">
                  <div className="checkbox-label">
                    <input type="checkbox" id="vehicle1" name="vehicle1" checked={isChecked} onChange={() => handleCheckboxChange()} />
                    <label htmlFor="vehicle1" className="chklabel">
                      <span className="f-16">
                        {t('DEVLOPMENT_ORDER.TESTING.ADD_TO_LIBRARY.BOM_COMPONENT_MESSAGE')}
                        <br />
                      </span>
                    </label>
                  </div>
                  <br />
                  <p className="tagWithMargin">{t('DEVLOPMENT_ORDER.TESTING.ADD_TO_LIBRARY.REMOVE_LIBRARY_MESSAGE')}</p>
                </div>
              )}
            </div>
          </FormGroup>
        )}

        <div className="common-model-footer">
          <button className="btn p-0" onClick={() => submitCode(code)} type="button">
            <span className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AddToLibrary;
